import { Settings2, Wifi, LockKeyhole, Cog, Lightbulb } from '@tamagui/lucide-icons';
import React from 'react';
import { useTranslation } from 'react-i18next';
import { Outlet, useLocation, useNavigate } from 'react-router-dom';
import { YStack, XStack, H2, ScrollView } from 'tamagui';
import { tokens } from 'tamagui-config';

import { MenuItem } from './components/MenuItem';
import { ROUTE_PATHNAMES } from '../../routes/routeConstants';

export const Settings: React.FC = () => {
  const { t } = useTranslation();
  const { pathname } = useLocation();
  const navigate = useNavigate();

  return (
    <XStack>
      {/* Settings Menu */}
      <YStack width={480} backgroundColor="$gray2" overflow="hidden">
        <H2 size="$6" margin="$5" marginTop="$8" lineHeight="$5">
          Settings
        </H2>
        <ScrollView
          flex={1}
          contentContainerStyle={{ gap: '$3.5', paddingBottom: '$6' }}
          showsVerticalScrollIndicator={false}>
          <MenuItem
            icon={<Settings2 size={40} color={tokens.color.textLight} />}
            label={t('settings.links.general')}
            isActive={pathname === ROUTE_PATHNAMES.settings}
            onPress={() => navigate(ROUTE_PATHNAMES.settings)}
          />

          <MenuItem
            icon={<LockKeyhole size={40} color={tokens.color.textLight} />}
            label={t('settings.links.lockScreen')}
            isActive={
              pathname === ROUTE_PATHNAMES.lockScreen ||
              pathname === ROUTE_PATHNAMES.setPin ||
              pathname === ROUTE_PATHNAMES.resetPin ||
              pathname === ROUTE_PATHNAMES.disablePin
            }
            onPress={() => navigate(ROUTE_PATHNAMES.lockScreen)}
          />

          <MenuItem
            icon={<Wifi size={40} color={tokens.color.textLight} />}
            label={t('settings.links.wifi')}
            isActive={pathname === ROUTE_PATHNAMES.wifi || pathname === ROUTE_PATHNAMES.connectWifi}
            onPress={() => navigate(ROUTE_PATHNAMES.wifi)}
          />

          <MenuItem
            icon={<Lightbulb size={40} color={tokens.color.textLight} />}
            label={t('settings.links.backlight')}
            isActive={pathname === ROUTE_PATHNAMES.backlight}
            onPress={() => navigate(ROUTE_PATHNAMES.backlight)}
          />

          <MenuItem
            icon={<Cog size={40} color={tokens.color.textLight} />}
            label={t('settings.links.serviceContact')}
            isActive={pathname === ROUTE_PATHNAMES.contact}
            onPress={() => navigate(ROUTE_PATHNAMES.contact)}
          />
        </ScrollView>
      </YStack>

      {/* Main Content Area */}
      <YStack width={1220} backgroundColor="$gray1" overflow="hidden">
        <Outlet />
      </YStack>
    </XStack>
  );
};
